/* eslint-disable react/jsx-closing-bracket-location */
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ShowPassword from '../../Common/ShowPassword';

import { formValidator } from '../../../AppUtil/AppUtil';
import BasicCountryCodeField from '../../Common/BasicCountryCodeField';
import BasicInputField from '../../Common/BasicInputField';
import BasicTextField from '../../Common/BasicTextField';
import { commonStyle } from '../../Common/CommonStyle';
import Error from '../../Common/Error';

import BasicButtons from '../../Common/BasicButtons';
import '../../Common/style.css';
import '../style.css';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_countryCode: this.props.user.countryCode || '+63',
			_welcomeHeading: '',
			_disabled: false,
			_changePassword: true,

			_signInForm: {
				phone: {
					value: this.props.user.phone || '',
					placeholder: 'label.contact',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_contact'
						},
						pattern: {
							value: PATTERN.CONTACT,
							errorMsg: 'error_message.invalid_contact'
						}
					},
					error_text: ''
				},
				password: {
					value: '',
					placeholder: 'label.password',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_password'
						}
					},
					error_text: ''
				}
			}
		};
	}

	/**
	 * This function handle all input change event inside login form
	 * @returns {void}
	 */
	handelInputChange = e => {
		this.props.resetAuthError();
		const name = e.target.name;
		let value = e.target.value;
		const loginForm = {
			...this.state._signInForm
		};
		const updatedFormElement = {
			...loginForm[name]
		};

		console.log(name);

		if (name === 'phone') {
			value = value.replace(/[^\d]/g, '');
		}

		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		loginForm[name] = updatedFormElement;
		this.setState({
			_signInForm: loginForm
		});
	};

	/**
	 * This function handle submit login form
	 * @returns {Promise<void>}
	 */
	onSubmitHandler = async e => {
		e.preventDefault();
		this.props.resetAuthError();
		if (!this.formValidator()) {
			return false;
		}
		const countryCode = this.state._countryCode;
		const user = {
			username: countryCode + this.state._signInForm.phone.value,
			password: this.state._signInForm.password.value
		};
		await this.props.onSubmit(user);
	};

	/**
	 * This function validate all field in login form
	 */
	formValidator = () => {
		const form = {
			...this.state._signInForm
		};

		let flag = true;
		const [updatedForm, isFormValid] = formValidator(form);

		if (
			!updatedForm.phone.value.startsWith('9') &&
			updatedForm.phone.value.length > 0 &&
			this.state._countryCode === '+63'
		) {
			updatedForm.phone.isValid = false;
			updatedForm.phone.error_text = 'Phone Number must start with 9';
			flag = false;
		}

		this.setState({
			_signInForm: updatedForm
		});
		return isFormValid && flag;
	};

	resetPassword = () => {
		const signInForm = {
			...this.state._signInForm
		};
		signInForm.password.value = '';
		this.setState({
			_signInForm: signInForm
		});
	};

	setHeadingWhenLoanObjectExist = () => {
		if (this.props.user.emailId !== '') {
			this.setState({
				_welcomeHeading: 'signin.main_heading',
				_disabled: true
			});
		}
	};

	componentDidMount() {
		this.setHeadingWhenLoanObjectExist();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.resetLoginForm !== this.props.resetLoginForm && this.props.resetLoginForm) {
			this.resetPassword();
		}
	}
	setCountryCode = e => {
		this.setState({
			_countryCode: e.target.value,
			_signInForm: {
				...this.state._signInForm,
				phone: {
					...this.state._signInForm.phone,
					value: ''
				}
			}
		});
	};
	render() {
		const { classes } = this.props;
		const { t } = this.props;

		const changeIcon = this.state._changePassword === true ? false : true;

		return (
			<Container component="main" maxWidth="md">
				<CssBaseline />
				<Paper className={classes.paper} id={'form-opacity-none'}>
					<Grid
						container
						justify="center"
						spacing={3}
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center'
						}}>
						<Grid
							item
							// sm={6}
							xs={12}
							className="login-form-wrapper-parent">
							<Paper id="login-form-wrapper">
								<div className={classes.paper}>
									<Typography id="auth-form-heading" component="h1" variant="h5">
										{/* {t('signin.sign_in')} */}
										LOG IN
									</Typography>
									<Typography className="text-center light-gray">
										{t(this.state._welcomeHeading)}
									</Typography>
									<form className={classes.form} noValidate onSubmit={this.onSubmitHandler}>
										<Grid
											style={{ backgroundColor: '', position: 'relative', paddingTop: '40px' }}
											container
											justify="center"
											spacing={1}>
											<label
												className="auth-form-input-header"
												style={{ backgroundColor: '', position: 'absolute', left: 5 }}>
												{`Mobile Number` + '*'}
											</label>
											<Grid item sm={2} xs={3} style={{ backgroundColor: '' }}>
												<BasicCountryCodeField
													setCountryCode={this.setCountryCode}
													value={this.state._countryCode}
												/>
											</Grid>
											<Grid
												item
												sm={10}
												style={{ marginTop: '16px', backgroundColor: '' }}
												xs={9}>
												<BasicInputField
													className="bold-important"
													onChange={this.handelInputChange}
													label={'Mobile Number'}
													error={
														!this.state._signInForm.phone.isValid &&
														this.state._signInForm.phone.isTouched
													}
													maxLength={10}
													helperText={t(this.state._signInForm.phone.error_text)}
													value={this.state._signInForm.phone.value}
												/>
											</Grid>
										</Grid>
										<BasicTextField
											style={{ marginBottom: 0, fontSize: 12 }}
											marginTop="14px"
											id="password"
											icon={
												<ShowPassword
													onClick={() => {
														this.setState({ _changePassword: changeIcon });
													}}
													changeIcon={changeIcon}
												/>
											}
											label={t(this.state._signInForm.password.placeholder)}
											value={this.state._signInForm.password.value}
											onChange={this.handelInputChange}
											error={
												!this.state._signInForm.password.isValid &&
												this.state._signInForm.password.isTouched
											}
											helperText={
												!this.state._signInForm.password.isValid &&
												this.state._signInForm.password.isTouched
													? t(this.state._signInForm.password.error_text)
													: ''
											}
											type={this.state._changePassword ? 'password' : 'text'}
											name="password"
											placeholder="Password"
											onSubmit={this.onSubmitHandler}
											onKeyPress={e => {
												if (e.key === 'Enter') {
													this.onSubmitHandler(e);
												}
											}}
										/>

										<Error text={this.props.authError} />
										<div
											className={classes.blockdiv}
											style={{
												backgroundColor: '',
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'center',
												justifyContent: 'space-between',
												marginTop: '40px',
												height: '160px'
											}}>
											<BasicButtons
												onClick={this.onSubmitHandler}
												type={'login'}
												text="log in"
												inverted={true}
												isLoaderOn={this.props.isLogInBtnLoaderOn}
												loader={<CircularProgress disableShrink size={18} />}
											/>
											<Link
												href="#"
												onClick={e => {
													e.preventDefault();
													this.props.openForgotPasswordScreen();
												}}
												variant="body2">
												{/* {t('signin.forgot_password').toUpperCase()} */}
												<label className="login-links">FORGOT PASSWORD</label>
											</Link>
											<Link
												href="#"
												onClick={e => {
													e.preventDefault();
													this.props.openSignUpForm();
												}}
												variant="body2">
												{/* {t('signin.dont_have_account')} */}
												<label className="login-links">CREATE AN ACCOUNT</label>
											</Link>
										</div>
									</form>
								</div>
							</Paper>
							<Paper id="form-opacity-none">{this.props.footer}</Paper>
						</Grid>
					</Grid>
					<Grid id="full-wdith" item md zeroMinWidth />
				</Paper>
			</Container>
		);
	}
}

export default withStyles(commonStyle)(withTranslation()(index));
